import React, { useEffect, useState } from 'react';
import { ResponsivePie } from "@nivo/pie";
import { fetchUsersCountryPie } from '../../http/userAPI';

const UsersByCountryPie = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchUsersCountryPie().then(setData).catch(console.error);
    }, []);

    if (!data.length) {
        return <div className="text-muted text-center py-4">Loading chart...</div>;
    }

    return (
        <div style={{ height: 380, width: '100%' }}> {/* Ключевой стиль! */}
            <ResponsivePie
                data={data}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.5}
                padAngle={1.5}
                cornerRadius={5}
                activeOuterRadiusOffset={8}
                colors={{ scheme: "category10" }}
                borderWidth={2}
                borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333"
                arcLinkLabelsThickness={2}
                arcLinkLabelsColor={{ from: "color" }}
                arcLabelsSkipAngle={10}
                arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
                arcLabel={e => e.value >= 4 ? `${e.value.toFixed(2).replace('.', ',')} %` :
                    `${e.value.toFixed(0)}`}
                tooltip={({ datum }) => (
                    <div
                        style={{
                            padding: 6,
                            background: 'white',
                            border: '1px solid #ccc',
                            borderRadius: 4,
                            fontSize: '0.85rem',
                            color: '#333',
                        }}
                    >
                        <strong>{datum.label}</strong>: <strong className="text-danger">{datum.value.toFixed(2).replace('.', ',')} % </strong>
                    </div>
                )}
                legends={[
                    {
                        anchor: "bottom",
                        direction: "row",
                        translateY: 54,
                        itemWidth: 50,     // было 100
                        itemHeight: 10,    // было 18
                        itemsSpacing: 8,   // было 10
                        itemTextColor: "#999",
                        symbolSize: 14,    // было 18
                        symbolShape: "circle",
                        effects: [
                            {
                                on: "hover",
                                style: { itemTextColor: "#000" }
                            }
                        ]
                    }
                ]}
            />
        </div>
    );
};

export default UsersByCountryPie;
